<script>
export default {
    props: {
        title: {
            type: [String, Boolean],
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        reserveSubtitle: {
            type: Boolean,
            default: false,
        },
        padded: {
            type: Boolean,
            default: false,
        },
        short: {
            type: Boolean,
            default: false,
        },
        showAllLink: {
            type: [Object, Boolean],
            default: () => null,
        },
        showAllTitle: {
            type: String,
            default: 'show all',
        },
    },
}
</script>

<template>
    <section
        :class="[
            $style.section,
            padded ? $style.sectionPadded : '',
            short ? $style.sectionShort : '',
        ]"
    >
        <div
            v-if="title || subtitle || reserveSubtitle"
            :class="$style.titleRow"
        >
            <h5 :class="$style.title">{{ title }}</h5>
            <slot name="right" />
            <router-link
                v-if="showAllLink"
                :to="showAllLink"
                :class="$style.link"
            >
                {{ showAllTitle }} <BaseIcon
                    :class="[$style.icon, $style.iconArrowRight]"
                    name="arrow-long-right"
                />
            </router-link>
            <div
                v-if="subtitle || reserveSubtitle"
                :class="[$style.subtitle, !subtitle ? $style.subtitleReserved : '']"
            >{{ subtitle }}</div>
        </div>
        <slot />
    </section>
</template>

<style lang="scss" module>
@import '@design';

.section {
    margin-top: $size-grid-padding * 3;

    &Short {
        margin-top: 0;
    }

    @include tablet {
        margin-top: 0;

        @include container;
    }

    &Padded {
        @include sidePadding;
    }
}
.section + .section {
    margin-top: $size-grid-padding * 3;

    @include desktop {
        margin-top: $s-h;
    }
}

.title {
    margin: 0;

    @include h6;

    @include desktop {
        @include h5;
    }
}

.subtitle {
    @extend %contentSubtitleS;

    min-width: 100%;
    margin: 0;

    &Reserved {
        min-height: 20px;
        visibility: hidden;
    }
}

.titleRow {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: space-between;
    margin-top: 0;
    margin-bottom: $size-large-grid-padding;

    .link {
        @extend %contentTextButton;

        .iconArrowRight {
            width: 14px;
            height: 11px;
            margin-left: $s-s;
            vertical-align: middle;
            fill: $c-highlight;
        }
    }
}
</style>
